import React from 'react';
import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';
import debounce from 'lodash/debounce';
import { remCalc } from '../../../util/style-util';
import { Resource } from 'types';
import { resourceLightGray, black } from '../../../styles/style-constants';
import PinIcon from 'assets/icons/PinIcon';
import PinnedIcon from 'assets/icons/PinnedIcon';
import BasicButton from '../../@common/Buttons/BasicButton';
import maybe from '../../../components/@common/enhancers/maybe';

type Props = {
  resource: Resource;
  hasUnpinIcon?: boolean;
  isFavoritePage?: boolean;
  onClickPinIcon: (event: Event) => void;
};
function ResourceItemFooter(props: Props) {
  function getDebouncedHandler(callback: (event: Event) => void, wait: number) {
    event?.stopPropagation();
    const debounced = debounce(callback, wait);

    return function (e: Event | any) {
      e.stopPropagation();
      e.persist();
      debounced(e);
    };
  }

  const { resourceItemFooter, leftSideFooter, iconContainer, iconImg } = useStyles();
  const MaybeAlternateIcon: any = maybe(BasicButton);

  return (
    <div className={resourceItemFooter}>
      <div className={leftSideFooter}>
        <div className={iconContainer}>
          <img
            className={iconImg}
            alt={props.resource?.type?.title}
            title={props.resource?.type?.title}
            src={props.resource?.type?.icon}
          />
        </div>
        <MaybeAlternateIcon
          shouldRender={props.resource?.type?.icon.alternate !== undefined}
          buttonStyles={iconContainer}
        >
          <img
            className={iconImg}
            alt={props.resource?.title}
            title={props.resource?.title}
            src={props.resource?.type?.icon.alternate}
          />
        </MaybeAlternateIcon>
      </div>
      <div>
        {!props.isFavoritePage && (
          <Button
            disableRipple
            className={iconContainer}
            onClick={getDebouncedHandler(props.onClickPinIcon, 200)}
          >
            {props.hasUnpinIcon ? <PinnedIcon /> : <PinIcon fillPin={'transparent'} fill={black} />}
          </Button>
        )}
      </div>
    </div>
  );
}

const useStyles = makeStyles(() => ({
  resourceItemFooter: {
    paddingTop: remCalc(5),
    paddingBottom: remCalc(5),
    backgroundColor: '#F5F5F5',
    borderTop: remCalc(1) + ' solid' + resourceLightGray,
    bottom: 0,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: remCalc(18)
  },
  leftSideFooter: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'center'
  },
  pinIconDiv: {
    position: 'relative',
    width: remCalc(35),
    height: remCalc(35),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0
  },
  unpinIconDiv: {
    position: 'absolute',
    top: -10,
    right: -10,
    width: remCalc(35),
    height: remCalc(35),
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2,
    padding: 0
  },
  iconContainer: {
    width: 'max-content !important',
    height: remCalc(32),
    marginRight: '-8px !important',
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent !important',
    '&:focus': {
      outline: 'none !important'
    }
  },
  iconImg: {
    marginLeft: remCalc(6),
    width: remCalc(37),
    height: remCalc(35)
  }
}));

export default ResourceItemFooter;
